import React, { useState } from 'react'
import { endpointData } from "../../data/endpointData";
import EmailReport from './EmailReport';
import INEReport from './INEReport';
import PhoneReport from './PhoneReport';
import IPReport from './IPReport';
import CURPReport from './CURPReport';


function Sandbox({ activeEndpoint }) {

    const [showReport, setShowReport] = useState(false);

    return (
        <div className="sandbox_flex">
            <div className="sandbox_form">
                <div className="sandbox_form_wrapper">
                    <h2>{endpointData[activeEndpoint].endpointTitle}</h2>
                    <p>{endpointData[activeEndpoint].endpointDescription}</p>
                    <div className="form_input_list">
                        {
                            endpointData[activeEndpoint].params
                                .map((param, paramIndex) => (
                                    <div className="input_container" key={activeEndpoint + "" + paramIndex}>
                                        <div className="input_label_flex">
                                            <label>{param.name}</label>
                                            <span className={!param.isOptional ? "active" : ""}>{!param.isOptional ? "Required" : "Optional"}</span>
                                        </div>
                                        <input type="text" readOnly value={param.demoValue} />
                                    </div>
                                ))
                        }
                        <div className="btn btn_primary" onClick={() => setShowReport(true)}>
                            <span>Send request</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sandbox_report">
                { showReport && endpointData[activeEndpoint].id == "a6cc88ec-6a7a-4b98-9274-f9645a50d062" && <EmailReport />}
                { showReport && endpointData[activeEndpoint].id == "48662deb-c14d-453e-9784-70832a7605e0" && <CURPReport />}
                { showReport && endpointData[activeEndpoint].id == "05c6fc42-c8c6-462d-9448-118800749b92" && <INEReport />}
                { showReport && endpointData[activeEndpoint].id == "1f581de8-53db-4f27-80ed-3a3afd327f9c" && <PhoneReport />}
                { showReport && endpointData[activeEndpoint].id == "9dc41379-1865-4415-9eb0-a9a5bb454368" && <IPReport />}
            </div>
        </div>
    )
}

export default Sandbox